<div class="file-container" appDnd (fileDropped)="onFileDropped($event)">
  <div *ngIf="imageUrl">
    <img [src]="imageUrl" class="selected-image" />
  </div>

  <input type="file" #fileDropRef id="fileDropRef" [multiple]="multiple" [accept]="supportedFormats"
    (change)="fileBrowseHandler($event.target.files)" />
  <img src="assets/images/ic-upload-file.svg" alt="" />
  <h3>Drag and drop image here</h3>
  <h3>or</h3>
  <label for="fileDropRef">Browse</label>
</div>